import DashDrawerNavigator from './DashDrawerNavigator'

export default DashDrawerNavigator
